import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

export default function CommonDialog({
	open,
	question,
	cancelAction,
	confirmAction,
}) {
	return (
		<div>
			<Dialog
				open={open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{question}</DialogTitle>
				<DialogContent></DialogContent>
				<DialogActions>
					<Button onClick={cancelAction}>Ні</Button>
					<Button onClick={confirmAction} autoFocus>
						Так
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
